// extracted by mini-css-extract-plugin
module.exports = {"section":"DidYouMean_section__r1MdG","result":"DidYouMean_result__4ahX_","highlight":"DidYouMean_highlight__kaptV"};